export default __webpack_public_path__ + "static/media/go_back.f0be2630.svg";